import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Button from '../ui/Button';

interface CollapseToggleProps {
  collapsed: boolean;
  /** Sem onToggle, vira só o indicador visual — para quando o cabeçalho inteiro já é o botão. */
  onToggle?: () => void;
}

/**
 * Recolher/expandir de uma seção da área de trabalho. É um ícone discreto, e não um
 * botão com texto, para não disputar atenção com a ação principal da seção.
 */
const CollapseToggle: React.FC<CollapseToggleProps> = ({ collapsed, onToggle }) => {
  const label = collapsed ? 'Expandir' : 'Recolher';
  const icon = (
    <ChevronDownIcon
      aria-hidden
      className={`h-5 w-5 transition-transform ${collapsed ? '-rotate-90' : ''}`}
    />
  );
  const className = 'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-fg-subtle';

  if (!onToggle) {
    return <span className={className} title={label}>{icon}</span>;
  }
  return (
    <Button variant="ghost" size="sm" iconOnly onClick={onToggle} title={label} aria-label={label} aria-expanded={!collapsed}>
      {icon}
    </Button>
  );
};

export default CollapseToggle;
